import { Image } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import LightTheme from "../../styles/LightTheme.png";
import DarkTheme from "../../styles/DarkTheme.png";
import AutoTheme from "../../styles/AutoTheme.png";
import { updateLanguage, updateTheme } from "../../slices/util.slice";

const THEMES = [
  { id: "light", label: "ڕۆشن", image: LightTheme },
  { id: "dark", label: "تاریک", image: DarkTheme },
  { id: "auto", label: "ئۆتۆ", image: AutoTheme },
];

const LANGS = [
  { id: "ku", label: "کوردی" },
  { id: "ar", label: "عەرەبی" },
  { id: "en", label: "ئینگلیزی" },
];

function Appearance() {
  const themeName = useSelector((state) => state.util.theme);
  const language = useSelector((state) => state.util.language);
  const dispatch = useDispatch();

  return (
    <section className="settings-card">
      <h3 className="settings-block-title">ڕووکار</h3>
      <div className="settings-themes">
        {THEMES.map((item) => (
          <button key={item.id} type="button" className={`settings-theme${themeName === item.id ? " is-on" : ""}`} onClick={() => dispatch(updateTheme(item.id))}>
            <Image preview={false} src={item.image} alt={item.label} />
            <span>{item.label}</span>
          </button>
        ))}
      </div>

      <h3 className="settings-block-title">زمان</h3>
      <div className="settings-langs">
        {LANGS.map((item) => (
          <button key={item.id} type="button" className={`hr-chip${language === item.id ? " is-on" : ""}`} onClick={() => dispatch(updateLanguage(item.id))}>
            {item.label}
          </button>
        ))}
      </div>
    </section>
  );
}

export default Appearance;
